<template src="./modalPrivacy.html"></template>

<script>
import DismissButton from '@/components/shared/DismissButton.vue'

export default {
	name: 'ModalPrivacy',
	emits: [],
	props: [],
	data() {
		return {}
	},
	beforeMount() {
	},
	mounted() {

	},
	components: { DismissButton },
	methods: {}

}
</script>
